<template>

  <form
      id='shipping-details-form'
      class='form'
      @submit.prevent='submitForm'
  >

    <!--
        <SfInput
            v-if="!isShipping"
            v-model="address.addressKey"
            :error-message="$t('Address name is required')"
            :label="$t('Address label')"
            :valid="addressKeyBlur || validAddressKey(address.addressKey)"
            class="form__element"
            name="addressKey"
            required
            @blur="addressKeyBlur = false"
        />
    -->
    <div class='form__horizontal'>

      <SfInput
          v-model="address.lastName"
          :error-message="address.lastName ? $t('addressForm.lastName.error') : $t('addressForm.lastName.required') "
          :label="$t('Last Name')"
          :valid="lastNameBlur || validLastName(address.lastName)"
          class="form__element"
          name="last-name"
          required
          @blur="lastNameBlur = false"
      />
      <SfInput
          v-model="address.firstName"
          :error-message="address.firstName? $t('addressForm.firstName.error') :$t('addressForm.firstName.required') "
          :label="$t('First name')"
          :valid="firstNameBlur || validFirstName(address.firstName)"
          class="form__element"
          name="first-name"
          required
          @blur="firstNameBlur = false"
      />
    </div>
    <div class='form__horizontal'>
      <SfInput
          v-model='address.company'
          :label="$t('Company')"
          class="form__element"
          name='company'
      />
    </div>
    <div class='form__horizontal'>
      <SfInput
          v-model='address.street'
          :errorMessage="address.street ? $t('addressForm.street.error'):$t('addressForm.street.required')"
          :label="$t('Street Name')"
          :valid='streetBlur || validStreet(address.street)'
          class="form__element"
          name='street'
          required
          @blur="streetBlur=false"
      />
    </div>

    <div class='form__horizontal'>

      <SfInput
          v-model='address.city'
          :errorMessage="address.city ? $t('addressForm.city.error'): $t('addressForm.city.required')"
          :label="$t('City')"
          :valid='cityBlur || validCity(address.city)'
          class="form__element"
          name='city'
          required
          @blur="cityBlur=false"
      />


      <SfInput
          v-model='address.postCode'
          :errorMessage="address.postCode ? $t('addressForm.postCode.error') : $t('addressForm.postCode.required')"
          :label="$t('Zip-code')"
          :valid="postCodeBlur || validPostCode(address.postCode)"
          class="form__element"
          name='postCode'
          required
          @blur="postCodeBlur = false"
      />
    </div>

    <div class='form__horizontal'>
      <SfSelect
          v-model='address.country'
          :errorMessage="address.country ? $t('addressForm.country.error') : $t('addressForm.country.required')"
          :label="$t('Country')"
          :placeholder="$t('Select a country')"
          :valid="countryBlur || validCountry(address.country)"
          class='form__element sf-select--underlined'
          name='country'
          required
          @blur="countryBlur = false"

      >
        <SfSelectOption
            v-for='country in countries'
            :key='country.code'
            :value='country.code'
        >
          {{ country[countryLang] }}
        </SfSelectOption>
      </SfSelect>

    </div>

    <div class='form__horizontal'>
      <SfInput
          v-model='address.phone'
          :errorMessage="address.phone ? $t('addressForm.phone.error') : $t('addressForm.phone.required')"
          :label="$t('Phone number')"
          :valid="phoneBlur || validPhoneNumber(address.phone)"
          class="form__element"
          name='phone'
          required
          @blur="phoneBlur = false"
      />
    </div>
    <div class='form__default__address'>
      <OrkToggle v-if="!isShipping"
                 v-model='address.defaultShipping'
                 :description="$t('Set as default shipping address')"
                 class='form__toggle'
                 name='shipping'
                 size="medium"></OrkToggle>

      <OrkToggle v-if="!isShipping"
                 v-model='address.defaultBilling'
                 :description="$t('Set as default billing address')"
                 class='form__toggle'
                 name='billing'
                 size="medium"></OrkToggle>

    </div>
    <div class='form__actions'>
      <SfButton :disabled="loading" class='sf-button color-white text-primary-color' type="submit">
        <div v-if="loading">
          <SfLoader :class="{ loader: loading }" :loading="loading"></SfLoader>
          {{ $t('Loading') }}
        </div>
        <div v-else> {{ isNew ? $t('Add the address') : $t('Save changes') }}</div>
      </SfButton>
    </div>
  </form>

</template>

<script>
import {SfLoader, SfButton, SfInput, SfSelect} from '@storefront-ui/vue';
import countries from "@/models/country-1.json";
import OrkToggle from "@/components/Ork/OrkToggle";
import {customer} from "@/store/customer";

let PhoneNumberValidation;
PhoneNumberValidation = require('awesome-phonenumber');
export default {
  name: 'AddressForm',

  components: {
    SfInput,
    SfLoader,
    SfButton,
    SfSelect,
    OrkToggle
  },
  data() {
    return {
      countryLang: "label_" + this.$i18n.locale,
      countries: countries,
      authorizedCountryList: process.env.VUE_APP_AUTHORIZED_COUNTRY_LIST,
      countryBlur: true,
      companyBlur: true,
      firstNameBlur: true,
      lastNameBlur: true,
      streetBlur: true,
      cityBlur: true,
      postCodeBlur: true,
      phoneBlur: true,
      defaultShipping: false,
      defaultBilling: false,
      errors: null,
      loading: false,
      valid: false,
      submitted: false,
    }
  },
  props: {
    address: {
      type: Object,
      default: () => ({
        name: '',
        company: '',
        firstName: '',
        lastName: '',
        street: '',
        city: '',
        postCode: '',
        country: 'FR',
        phone: '',
        defaultShipping: true,
        defaultBilling: true
      })
    },
    isNew: {
      type: Boolean,
      required: true
    },
    isShipping: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    customer: {
      get() {
         return this.$store.getters.getProfile
      }
    }
  },
  mounted() {
    if(this.authorizedCountryList){
      const CountryList = this.authorizedCountryList.split(',')
      this.countries = this.countries.filter((country) => CountryList.includes(country.code));
    }
    if (this.countries.length === 1) {
      this.$set(this.address,"country", this.countries[0].code)
    }
    this.countries.sort((a, b) => {
      return a[this.countryLang] > b[this.countryLang] ? 1 : -1;
    })
    if(!this.address.firstName) {
      if (this.customer.firstName) {
        this.$set(this.address, "firstName", this.customer.firstName)
      }
    }
    if(!this.address.lastName){
      if(this.customer.lastName){
        this.$set(this.address, "lastName", this.customer.lastName)
      }
    }
  },
  methods: {
    makeid(length) {
      let result = '';
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
            charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },

    validate() {
      this.firstNameBlur = false;
      this.lastNameBlur = false;
      this.cityBlur = false;
      this.phoneBlur = false;
      this.postCodeBlur = false;
      this.countryBlur = false;
      this.streetBlur = false;

      if (
          this.validCountry(this.address.country) &&
          this.validPhoneNumber(this.address.phone) &&
          this.validPostCode(this.address.postCode) &&
          this.validCity(this.address.city) &&
          this.validStreet(this.address.city) &&
          this.validFirstName(this.address.firstName) &&
          this.validLastName(this.address.lastName)
      ) {
        this.valid = true;
      }
    },

    validPhoneNumber(phone) {
      let pn;
      let regionCode;
      if (this.address.country) {
        regionCode = this.address.country
        pn = new PhoneNumberValidation(phone, regionCode);
      } else {
        regionCode = new PhoneNumberValidation(phone).getRegionCode();
        pn = new PhoneNumberValidation(phone, regionCode);
      }
      if (pn.isValid()) {
        this.address.phone = pn.getNumber('international');
      }
      return pn.isValid();
    },
    validFirstName(firstName) {
      return firstName.length > 2;
    },
    validCity(city) {
      return city.length > 2;
    },
    validStreet(street) {
      return street.length > 2;
    },
    validCountry(country) {
      return country.length > 0;
    },
    validPostCode(postCode) {
      const regex = /^\d+$/;
      return regex.test(postCode);
    },
    validLastName(lastName) {
      return lastName.length > 2;
    },

    submitForm() {
      const onComplete = () => {
        if (!this.error || this.error.status === 200) {
          this.loading = false;
        } else {
          this.loading = false;
        }
      };

      const onError = (e) => {
        this.error = e;
        this.loading = false;
      };
      this.validate()
      if (this.valid) {
        if (!this.address.name) {
          this.address.name = this.address.street.normalize("NFD").replace(/[\u0300-\u036f]/g, '').replace(/\s/g, '') + this.address.postCode.replace(/\s/g, '') + this.makeid(8)
        }
        this.loading = true;
        this.$emit('submit', {address: this.address, onComplete, onError});
      }
    },
  }
};
</script>

<style lang='scss' scoped>
form {
  padding: 0 var(--spacer-base);
  margin-bottom: var(--spacer-base);
}

.form__toggle {
  &:first-of-type {
    margin-bottom: var(--spacer-sm);
  }

  .title {
    display: none;
  }
}

.form__horizontal {
  display: flex;
  width: 100%;
  flex-wrap: wrap;

  .form__element {
    flex: 1;
    margin: var(--spacer-sm);
    @include for-mobile {
      width: 100%;
      flex: auto;
    }
  }
}


.form__default__address {
  margin: var(--spacer-base) 0;
  padding: 0 0 0 var(--spacer-sm);
}

.form__actions {
  margin-top: var(--spacer-lg);
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
}
</style>
